import { Button, Text, Flex } from "@beachfront/ui";
import { Link } from "react-router-dom";
import { useTheme } from "styled-components";

import logoBlack from "../../assets/img/bf-logo-horizontal-black.png";
import logoWhite from "../../assets/img/bf-logo-horizontal-white.png";

function PageMaintenance() {
    const theme = useTheme();

    return (
        <Flex
            gap={3}
            minHeight={300}
            height="calc(100vh - 40px)"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
        >
            <Link to="/">
                <img
                    alt="Beachfront Media"
                    src={theme.name === "light" ? logoBlack : logoWhite}
                    width={320}
                />
            </Link>
            <Text>We're sorry.</Text>
            <Text>We are currently performing maintenance.</Text>
            <Text>Please check back later.</Text>
        </Flex>
    );
}

export default PageMaintenance;
